import React from 'react';
import { Category, Answer, CategoryResponse } from '../types';
import QuestionCard from './QuestionCard';

interface QuestionnaireSectionProps {
  category: Category;
  responses: CategoryResponse;
  onAnswerChange: (questionId: string, answer: Answer) => void;
}

const QuestionnaireSection: React.FC<QuestionnaireSectionProps> = ({ 
  category, 
  responses, 
  onAnswerChange 
}) => {
  return (
    <div className="mb-8" style={{ WebkitOverflowScrolling: 'touch', touchAction: 'pan-y' }}>
      <div className="bg-primary/10 p-4 rounded-md mb-4">
        <h2 className="text-xl font-semibold text-foreground">{category.title}</h2>
      </div>
      
      <div className="mb-4">
        <QuestionCard
          question={category.question}
          answer={responses.answer}
          onChange={(answer) => onAnswerChange(category.question.id, answer)}
        />
      </div>
    </div>
  );
};

export default QuestionnaireSection;
